import React, { Fragment } from 'react';

function QuestionDollars({ onChange, questionId = '', label = '', value = '', autoFocus = true }) {
  return (
    <Fragment>
      {label && (
        <label htmlFor={'input-' + questionId} className="form__text-label">
          {label}
        </label>
      )}
      <span className="new-assessment-detail__dollar-sign">
        $
      </span>
      <input
        id={'input-' + questionId}
        type="number"
        onChange={onChange}
        value={value}
        autoFocus={autoFocus}
        className="new-assessment-detail__dollars-input"
      />
    </Fragment>
  );
}

export default QuestionDollars;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionDollars.js